import React from 'react';

import {RouteData} from '../types';
import {
  BENCHMARK_PATHS,
  NEW_BENCHMARK_PATH,
  NEW_BENCHMARK_PATH_WITH_ENTITY_NAME,
} from './benchmarkPaths';

/**
 * Benchmark routes - creating and viewing benchmarks.
 */
export const BENCHMARK_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'NewBenchmark',
    },
    isPrivateRoute: true,
    path: NEW_BENCHMARK_PATH,
    RouteComponent: React.lazy(() => import('../../pages/NewBenchmark')),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'NewBenchmark',
    },
    isPrivateRoute: true,
    path: NEW_BENCHMARK_PATH_WITH_ENTITY_NAME,
    RouteComponent: React.lazy(() => import('../../pages/NewBenchmark')),
  },
  {
    additionalProps: {
      allowIframes: true,
      routeName: 'Benchmark',
    },
    exact: true,
    isPrivateRoute: false,
    path: BENCHMARK_PATHS,
    RouteComponent: React.lazy(
      () => import('../../pages/Benchmark/BenchmarkPage')
    ),
  },
];
